<template>
	<div class="wrap">
		<myHead></myHead>
		<div class="wrap_body">
			<div class="center">
				<div class="ucenter_main">
					<ucMenu num="10"></ucMenu>
					<div class="right_con">
						<div class="setting_main">
							<p class="fb">运费策略</p>
							<div class="desc">请仔细查看下方运费模版内容和注意事项</div>
							<ul class="warn-list">
								<li>1. 发货快递及扣费按照运费模板来计算，优先发申通、申通不可达会发EMS；</li>
								<li>2. 如果申通和EMS均不可达，若要默认发顺丰的，需要用户先授权同意；</li>
								<li>3. 没有授权同意的，会暂停发货，客服会联系用户确认是否需要顺丰发货；</li>
								<li>4. 如果用户需要指定订单顺丰发货，也可在订单列表中进行提前标记（标记顺丰发货后先发顺丰）；</li>
							</ul>
							<div class="auth-box">
								<span>是否同意授权（申通与EMS均不可达时）平台顺丰发货：</span>
								<el-tag v-if="is_authorize==1" type="success">已授权</el-tag>
								<el-tag v-else type="info">未授权</el-tag>
								<el-button v-if="is_authorize==1" type="primary" size="mini" @click="handleAuth">取消授权</el-button>
								<el-button v-else type="primary" size="mini" @click="handleAuth">确认授权</el-button>
							</div>
							<div class="template-list">
								<div v-for="item in tableData" :key="item.id" class="template-card">
									<div class="template-header">
										<span class="template-title">{{ item.template_name }}</span>
									</div>
									<div class="template-info">
										运费类型：{{ item.type == 1 ? '阶梯计费' : '固定运费' }}
									</div>
									<div class="template-express">
										选择的快递：{{ item.delivery_name }}
									</div>
									<el-table :data="item.get_template_info" border style="width: 100%; margin-top: 10px;">
										<el-table-column label="收货地区" min-width="200">
											<template slot-scope="scope">
												<div style="white-space: normal; word-break: break-all;">
													{{ scope.row.areaNames || '默认' }}
												</div>
											</template>
										</el-table-column>
										<el-table-column label="计费规则" min-width="300">
											<template slot-scope="scope">
												<div v-if="item.type == 1">
													{{ scope.row.firstNum }}件以内，{{ scope.row.firstFee }}元；
													每增加{{ scope.row.addNum }}件，增加运费{{ scope.row.addFee }}元
												</div>
												<div v-else>
													{{ scope.row.fixedFee }}元
												</div>
											</template>
										</el-table-column>
									</el-table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<myFoot></myFoot>
	</div>
</template>

<script>
import Vue from 'vue';
import { mapActions,mapState,mapMutations } from "vuex";
import myHead from '../../components/myHead/myhead';
import myFoot from '../../components/myFoot/myfoot';
import ucMenu from '../../components/ucenterMenu/ucmenu';
import request from '@/assets/js/utils/request';

export default {
	name: "freight",
	data() {
		return {
			is_authorize: 0, // 是否已授权
			tableData: []
		}
	},
	components:{
		myHead,myFoot,ucMenu
	},
	computed:{

	},
	created(){
		this.fetchTemplateList();
		// 假设issq字段后端返回，暂时写死
		// this.is_authorize = true/false
	},
	methods: {
		...mapActions({
			getFreightTemplateList: "ucenter/getFreightTemplateList",
			doAuthorizeOperate: "ucenter/doAuthorizeOperate"
		}),
		fetchTemplateList() {
			this.getFreightTemplateList({
				data: {},
				success: (res) => {
					if (res.code === 200) {
						let data = res.data.data ? res.data.data : [];
						// 对每个模板的 get_template_info 进行排序
						data = data.map(item => {
							if (item.get_template_info && item.get_template_info.length > 0) {
								const areaRules = [...item.get_template_info];
								// 找出默认地区
								const defaultArea = areaRules.find(rule => !rule.areaNames || rule.areaNames === '默认');
								// 过滤出其他地区
								const otherAreas = areaRules.filter(rule => rule.areaNames && rule.areaNames !== '默认');

								// 对其他地区按照 firstFee 排序
								otherAreas.sort((a, b) => {
									const feeA = parseFloat(a.firstFee) || 0;
									const feeB = parseFloat(b.firstFee) || 0;
									return feeA - feeB;
								});

								// 合并数据，默认地区始终在第一位
								item.get_template_info = defaultArea ? [defaultArea, ...otherAreas] : otherAreas;
							}
							return item;
						});
						this.tableData = data;
						this.is_authorize = res.data.is_authorize;
					}
				}
			});
		},
		handleAuth() {
			const is_authorize = this.is_authorize == 1 ? 0 : 1;
			const msg = is_authorize === 1 ? '是否确认授权顺丰发货？' : '是否取消顺丰发货授权？';
			this.$confirm(msg, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.doAuthorizeOperate({
					data: { is_authorize },
					success: (res) => {
						if (res.code === 200) {
							this.$message.success(is_authorize === 1 ? '已授权顺丰发货' : '已取消授权');
							this.fetchTemplateList();
						} else {
							this.$message.error(res.msg || '操作失败');
						}
					}
				});
			});
		}
	}
}
</script>

<style scoped>

.center{display: flex;flex: 1;}

.setting_main{padding: 36px 40px;}
.setiting_wrap{padding-top: 25px;}
.desc {
	margin: 10px 0 10px 0;
	font-size: 15px;
	color: #333;
}
.warn-list {
	color: #f0413e;
	font-size: 14px;
	margin-bottom: 18px;
	margin-top: 0;
	padding-left: 18px;
}
.warn-list li {
	margin-bottom: 4px;
	line-height: 1.7;
}
.auth-box {
	margin-bottom: 24px;
	margin-top: 10px;
	font-size: 15px;
	display: flex;
	align-items: center;
	gap: 12px;
}
.template-list {
	margin-top: 10px;
}
.template-card {
	background: #f5f5f5;
	border: 1px solid #e4e4e4;
	border-radius: 6px;
	margin-bottom: 24px;
	padding: 20px;
}
.template-header {
	font-weight: bold;
	font-size: 18px;
	margin-bottom: 8px;
}
.template-info, .template-express {
	margin-top: 6px;
	color: #666;
	font-size: 14px;
}
</style>

